import {action} from 'mobx';
import PerformanceReviewQuestion from './PerformanceReviewQuestion';
import {QAAnswer} from 'main/stores/questions';

class PerformanceReviewAnswer extends QAAnswer {
  @action merge(other) {
    super.merge(other, {
      question: PerformanceReviewQuestion
    });
  }
}

export default PerformanceReviewAnswer;
